import FusionClass from '@didi/fusion'
export default new FusionClass()
